import { SUPPORT_WHATSAPP_URL } from '../config/support.js';

/**
 * 403 (#1317): what "contact us" does. While a support chat runs (or is still loading) it opens that chat — a tap made
 * during loading is kept and honoured once the chat is ready. With no chat, or a chat that failed to load, it is
 * WhatsApp, exactly as before, so a customer is never left with nowhere to ask. `SupportChat` reports the chat's state.
 */
type ChatState = 'none' | 'loading' | 'ready' | 'failed';

let state: ChatState = 'none';
let opener: (() => void) | null = null;
let pending = false;

const openWhatsApp = () => {
  window.open(SUPPORT_WHATSAPP_URL, '_blank', 'noopener,noreferrer');
};

export function chatStarting(): void {
  state = 'loading';
}

export function chatReady(open: () => void): void {
  state = 'ready';
  opener = open;
  if (pending) {
    pending = false;
    open();
  }
}

export function chatFailed(): void {
  state = 'failed';
  opener = null;
  if (pending) {
    pending = false;
    openWhatsApp();
  }
}

/** True while a chat runs or is loading: the links take the tap instead of following WhatsApp. */
export function chatAvailable(): boolean {
  return state === 'loading' || state === 'ready';
}

export function openSupport(): void {
  if (state === 'ready' && opener) {
    opener();
    return;
  }
  if (state === 'loading') {
    pending = true;
    return;
  }
  openWhatsApp();
}

/** Tests only. */
export function resetSupportForTests(): void {
  state = 'none';
  opener = null;
  pending = false;
}
